import { Button, ErrorMessage, Screen, Text, TextInput } from "components"
import React, { useEffect, useState } from "react"
import { ActivityIndicator, View, useWindowDimensions } from "react-native"
import { style } from "./styles"
import { useNavigation } from "@react-navigation/native"
import { translate } from "i18n"
import { Controller, useForm } from "react-hook-form"
import DropDownPicker from "react-native-dropdown-picker"
import Icon from "@expo/vector-icons/MaterialCommunityIcons"
import AntDesign from "@expo/vector-icons/AntDesign"
import { colors } from "colors"
import { useStores } from "models"
import Modal from "react-native-modal"
import Scanner from "react-webcam-qr-scanner"
import { useSessionExpired } from "utils/function"
import flash from "config/flash"
import { map, size } from "lodash"
import useResponsiveWidth from "components/fitSize"

export const EmployeeIssueVoucherScreen = () => {
  const { userStore } = useStores()
  const { sessionExpired } = useSessionExpired()
  // const { width } = useWindowDimensions()
  const getResponsiveWidth = useResponsiveWidth()
  const { width } = getResponsiveWidth()

  const navigation = useNavigation<any>()
  const [voucher, setVoucher] = useState([])
  const [branch, setBranch] = useState([])
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [voucherModalVisible, setVoucherModalVisible] = useState(false)
  const [branchModalVisible, setBranchModalVisible] = useState(false)

  const { control, handleSubmit, clearErrors, setValue } = useForm({
    reValidateMode: "onSubmit",
  })

  useEffect(() => {
    getVoucher()
    getBranch()
  }, [])

  const onCloseModal = () => {
    setIsModalVisible(false)
  }

  const handleDecode = (result) => {
    console.log(result?.data)
    if (result?.data) {
      setIsModalVisible(false)
      setValue("memberID", result?.data)
    }
  }

  // prevent multiple calls within seconds
  const debounce = (fn, delay) => {
    let timerId
    return (...args) => {
      clearTimeout(timerId)
      timerId = setTimeout(() => fn(...args), delay)
    }
  }

  const getVoucher = async () => {
    const typesArray = ["employee_voucher"]

    await fetch(`${process.env.API_URL}/api/voucher?types=${typesArray}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        if (res?.ok) {
          const responseData = await res?.json()
          const data = map(responseData, (e) => {
            return { label: e?.title, value: e?.voucher_id }
          })

          setVoucher(data)
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          } else {
            flash("error", translate("errors.failedToRetreiveVoucher"))
          }
        }
      })
      .catch((e) => {
        flash("error", translate("errors.failedToRetreiveVoucher"))
        console.error(e)
      })
  }

  const getBranch = async () => {
    await fetch(`${process.env.API_URL}/api/outlet/employee/${userStore?.id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        if (res?.ok) {
          const responseData = await res?.json()
          const data = map(responseData, (e) => {
            return { label: e?.outlet_name, value: e?.outlet_id }
          })

          setBranch(data)

          if (size(data) === 0) {
            flash("error", "employeeIssueVoucherScreen.noBranch")
            navigation.goBack()
          }
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          } else {
            flash("error", translate("errors.failedToRetreiveVoucher"))
          }
        }
      })
      .catch((e) => {
        flash("error", translate("errors.failedToRetreiveVoucher"))
        console.error(e)
      })
  }

  const onSubmit = async (data) => {
    await fetch(`${process.env.API_URL}/api/voucher/redeem`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
      body: JSON.stringify({
        voucher_id: data?.selectedVoucher,
        member_code: data?.memberCode,
        outlet_id: data?.branch,
        employee_id: userStore?.id,
      }),
    })
      .then(async (res) => {
        if (res?.ok) {
          flash("success", translate("employeeIssueVoucherScreen.issueSuccess"))
          setValue("memberCode", "")
          setValue("selectedVoucher", "")
        } else {
          onCloseModal()
          const errorMsg = await res?.json()
          if (errorMsg?.message === "Token expired" || errorMsg?.message === "Invalid token") {
            sessionExpired()
          } else if (errorMsg?.message === "Error redeem voucher. No stock is available.") {
            flash("error", translate("errors.outOfStock"))
          } else if (errorMsg?.message === "Member not found") {
            flash("error", translate("errors.memberNotFound"))
          } else if (errorMsg?.message === "Member Exceeded Redeem Limit") {
            flash("error", translate("errors.memberExceedRedeem"))
          } else {
            flash("error", translate("errors.failedToRedeem"))
          }
        }
      })
      .catch((e) => {
        onCloseModal()
        flash("error", translate("errors.failedToRedeem"))

        console.error(e)
      })
  }

  return (
    <Screen>
      <View style={style.container}>
        <View style={style.containerWrapper}>
          <Text style={style.titleText}>{translate("employeeIssueVoucherScreen.title")}</Text>
          {/* <Icon
            onPress={() => {
              navigation.reset({ index: 0, routes: [{ name: "employee" }] })
              userStore?.resetAuthData()
            }}
            name={"logout"}
            size={30}
            color={colors.linearFirstColor}
          /> */}
        </View>
        <Controller
          name="branch"
          control={control}
          rules={{
            required: translate("errors.required"),
          }}
          render={({ field: { onChange, value }, fieldState: { error } }) => {
            return (
              <View>
                <View style={style.titleContainer}>
                  <Text style={style.title}>{translate("employeeIssueVoucherScreen.branch")}</Text>
                </View>
                <DropDownPicker
                  style={[style.dropdown, error && style.errorTextField]}
                  dropDownContainerStyle={{
                    borderColor: colors.inputFieldBorder,
                    backgroundColor: colors.placeholder,
                  }}
                  placeholderStyle={{
                    color: colors.placeholder,
                  }}
                  placeholder={translate("employeeIssueVoucherScreen.branchPlaceholder")}
                  open={branchModalVisible}
                  listMode="MODAL"
                  value={value}
                  items={branch}
                  setOpen={() => {
                    setBranchModalVisible(!branchModalVisible)
                  }}
                  onSelectItem={(e) => onChange(e?.value)}
                />
                {error && <ErrorMessage errorType={error.type} customMessage={error?.message} />}
              </View>
            )
          }}
        />
        <Controller
          name="name"
          control={control}
          defaultValue={userStore?.fullName}
          rules={{
            required: translate("errors.required"),
          }}
          render={({ field: { onChange, value }, fieldState: { error } }) => {
            return (
              <View>
                <TextInput
                  onFocus={() => clearErrors("name")}
                  value={value}
                  onChangeText={onChange}
                  error={error}
                  title={translate("employeeIssueVoucherScreen.employeeName")}
                  editable={false}
                  errorMessage={error?.message}
                  containerStyle={style.inputContainer}
                  style={style.inputStyle}
                />
              </View>
            )
          }}
        />
        <Controller
          name="memberCode"
          control={control}
          rules={{
            required: translate("errors.required"),
          }}
          render={({ field: { onChange, value }, fieldState: { error } }) => {
            return (
              <View>
                <TextInput
                  onFocus={() => clearErrors("memberCode")}
                  value={value}
                  onChangeText={onChange}
                  error={error}
                  rightIcon={() => (
                    <Icon
                      onPress={() => {
                        setIsModalVisible(true)
                      }}
                      name="camera"
                      size={25}
                      color={colors.placeholder}
                    />
                  )}
                  title={translate("employeeIssueVoucherScreen.memberCode")}
                  errorMessage={error?.message}
                  placeholder={translate("employeeIssueVoucherScreen.memberCode")}
                  containerStyle={style.inputContainer}
                  style={style.inputStyle}
                />
              </View>
            )
          }}
        />
        <Controller
          name="selectedVoucher"
          control={control}
          rules={{
            required: translate("errors.required"),
          }}
          render={({ field: { onChange, value }, fieldState: { error } }) => {
            return (
              <View>
                <View style={style.titleContainer}>
                  <Text style={style.title}>{translate("employeeIssueVoucherScreen.voucher")}</Text>
                </View>
                <DropDownPicker
                  style={[style.dropdown, error && style.errorTextField]}
                  dropDownContainerStyle={{
                    borderColor: colors.inputFieldBorder,
                    backgroundColor: colors.placeholder,
                  }}
                  placeholderStyle={{
                    color: colors.placeholder,
                  }}
                  placeholder={translate("employeeIssueVoucherScreen.voucherPlaceholder")}
                  open={voucherModalVisible}
                  listMode="MODAL"
                  value={value}
                  items={voucher}
                  setOpen={() => {
                    setVoucherModalVisible(!voucherModalVisible)
                  }}
                  onSelectItem={(e) => onChange(e?.value)}
                />
                {error && <ErrorMessage errorType={error.type} customMessage={error?.message} />}
              </View>
            )
          }}
        />
        <View style={style.buttonContainer}>
          <Button
            onPress={handleSubmit(onSubmit)}
            style={style.button}
            title={translate("common.submit")}
          />
        </View>
      </View>

      <Modal
        isVisible={isModalVisible}
        onBackdropPress={onCloseModal}
        onBackButtonPress={onCloseModal}
      >
        <View style={style.modalContainer}>
          <AntDesign onPress={onCloseModal} name="close" size={40} style={style.modalCloseButton} />
          <View style={style.cameraContainer}>
            <style>
              {`
          video {
            object-fit:fill;
            width: ${width - 60}px
          }
        `}
            </style>
            <Scanner
              onDecode={(res) => {
                debounce(handleDecode(res), 5000)
              }}
              constraints={{
                audio: false,
                video: {
                  facingMode: "environment",
                },
              }}
            />
            <ActivityIndicator
              size="large"
              color={colors.white}
              style={{ position: "absolute", zIndex: -1 }}
            />
          </View>
        </View>
      </Modal>
    </Screen>
  )
}
